<template>
    <div class="search-reports" @mouseover="OperatingWebsite()">
      <!-- <div class="search-img">
          <div class="img-ss">
              <img class="search-background" src="../assets/images/searchbackground.jpg" />
              <h1 class="search-title">{{$t('NavabarText.navbar_search')}}</h1>
          </div>
      </div> -->
      
       <banner>
            <img src="../assets/images/searchbackground.jpg"/>
            <div slot="title">{{$t('NavabarText.navbar_searchy')}}</div>
        </banner>
      <div class="search-content">
         
            <div class="content-item-right">
                <div class="content-item-input">
                    <input type="text" class="item-input" v-model="searchForm.Name" :placeholder="$t('ContractText.name')">
                </div>
                <div class="content-item-input">
                    <input type="text" class="item-input" v-model="searchForm.LaboratoryNo" :placeholder="$t('ContractText.labno')" >
                </div>
                <div class="content-item-input">
                    <div class="select-area">
                            <select id="selArea" class="select" v-model="searchForm.areaNo">
                                <option value="86">内地(86)</option>
                                <option value="00852">香港(00852)</option>
                                <option value="00853">澳门(00853)</option>
                            </select>
                            <input class="input-form" value='' v-model="searchForm.Phone" :placeholder="$t('ContractText.phone')" Id="Phone"/>
                    </div>
                    
                </div>
                <div class="content-item-input">
                    <div class="select-area">
                        <input type="text" class="input-forms"  v-model="searchForm.vertify" :placeholder="$t('ContractText.vertifys')" >
                        <span id="daoshushijian" class="error-img"></span>
                         <button  id="send-sms" class="form-btn-send" type="button" @click="sendMsg()"  :class="i<30?'send_smsspe':''" :disabled="i<30?true:false">
                            <span v-if="numTimer<1">{{$t('ContractText.send_sms')}}</span>
                            <span v-if="numTimer>=1">{{$t('ContractText.send_sms_second')}}</span>
                        </button>
                        <button  id="send-sms" class="form-btn-send" type="button" @click="SendMessagesByVoice()" v-if="numTimer>=1" :class="i<30?'send_smsspe':''" :disabled="i<30?true:false">
                            <span >{{$t('ContractText.speaker')}}</span>
                        </button>
                       
                    </div>
                </div>
                <!-- <div class="content-item-input">
                    <div class="sms-speaker" @click="SendMessagesByVoice()" v-if="numTimer>=2"></div>
                </div> -->
                <div class="content-item-input">
                    <div class="select-warning">
                        <div class="checekboxs-div">
                        <input type="checkbox"  :checked="checked" class="checekboxs" >
                        </div>
                        <div class="warning">{{$t('ContractText.warning')}}
                            <a style="color:#fff;text-decoration: underline;cursor: pointer;" @click="liJumps('privacy')">
                                <span >{{$t('ContractText.private')}}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="content-item-input">
                    <div classs="submit-div">
                        <button class="submit-btn" type="button" @click="submit()">{{$t('ContractText.mailbox_btn')}}</button>
                    </div>
                    
                </div>
            </div>
            <div class="content-item-left">
                <div class="item-left">
                    <div class="item-title">{{$t('ContractText.report_search_description')}}</div>
                    <ol>
                    <li class="item-content">{{$t('ContractText.description_one')}}</li>
                    <li class="item-content">{{$t('ContractText.description_two')}}</li>
                    <li class="item-content">{{$t('ContractText.description_three')}}</li>
                    <li class="item-content">{{$t('ContractText.description_four')}}</li>
                    <li class="item-content">{{$t('ContractText.description_five')}}</li>
                    </ol>
                </div>
            </div>
      </div>
      <div>
        <el-dialog title="" :visible.sync="dialogImgVisible" width="50%" :show-close='true'>
            <div>
                <div style="width:100%;text-align:right;margin-right:32px;margin-bottom:10px;">
                    <div class="btn_div">
                        <a class="btn_down" style="color:#fff;font-size:16px;cursor: pointer;" @click="downloadPdf()">
                            <span v-if="$i18n.locale=='zh-TCC'">下載報告</span>
                            <span v-if="$i18n.locale=='zh-CN'">下载报告</span>
                            <span v-if="$i18n.locale=='en-US'">Download</span>
                            <span class="icon iconfont iconbaocun baocun" ></span>
                        </a>
                    </div>
                </div>
                <div>
                <img id="fullResImage" :src="PdfImgUrl" style="height: 100%; width: 100%;" >
                </div>
            </div>
             
       </el-dialog>
      </div>
    </div>
</template>
<script>
import {SendMessage,LoginsImg,SendMessagesVoice} from '@/service/searchreport'
import banner from '@/components/banner'
export default {
    data(){
        return{
            searchForm:{
                areaNo:'86',
                LaboratoryNo:'',
                Name:'',
                Phone:'',
                vertify:'',
            },
            error:false,
            i:30,
            flag:1,
            timer:null,
            checked:true,
            numTimer:0,
            isDisabled:false,
             dialogImgVisible:false,
            PdfImgUrl:'',
            pdfUrl:'',
            currentTime: new Date().getTime()

        }
    },
    components: {
      banner,
     
    },
    mounted(){

            //  alert("抱歉，系統正在優化，請於14:30後再進行查詢");
            // return;
    },
    methods:{
          OperatingWebsite(){
        let currentTime = this.currentTime;
        let lastTime = new Date().getTime();
        let timeOut = 10 * 60 * 1000; //设置时间 10分钟
        if (lastTime - currentTime > timeOut) {
          // 未操作页面，跳转登录页面
          this.currentTime = new Date().getTime();
          const fullPath = this.$route.fullPath;
          let query=fullPath;
          this.$confirm('您当前页面停留时间过长，请刷新', '提示', {
              confirmButtonText: '確定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
               location.reload();
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消当前操作！'
            });          
          });
         
        } else {
          this.currentTime = new Date().getTime();
        }
      },
        validated(){
          let areaNo = this.searchForm.areaNo + '';
          let phone = this.searchForm.Phone + '';
          if (areaNo === '86' && phone.length !== 11){
            alert('請輸入11位内地電話號碼！');
            return false;
          }
          if (areaNo !== '86' && phone.length !== 8){
            alert('請輸入8位香港（澳门）電話號碼！');
            return false;
          }
          return true;

        },
        liJumps(path){
            this.$router.push({
            path:path
            })
        },
        //发送短信验证码
        sendMsg(){
            // alert("抱歉，系統正在優化，請於14:30後再進行查詢");
            // return;
            if(this.searchForm.LaboratoryNo==''){
                alert('請輸入報告編號！');
                return;
            }
            if(this.searchForm.Name==''){
                alert('請輸入受測者姓名！')
                return;
            }
            if(this.searchForm.Phone==''){
                alert('請輸入電話號碼！')
                return;
            }
            if (!this.validated())return;

            this.SendMessages();
        },
        //查询报告
        submit(){
            console.log('sdfd',this.searchForm);
            //  alert("抱歉，系統正在優化，請於14:30後再進行查詢");
            // return;
            if(this.searchForm.LaboratoryNo==''){
                alert('請輸入報告編號！');
                return;
            }
            if(this.searchForm.Name==''){
                alert('請輸入受測者姓名！')
                return;
            }
            if(this.searchForm.Phone==''){
                alert('請輸入電話號碼！')
                return;
            }
            if(this.searchForm.vertify==''){
                alert('請輸入驗證碼！')
                return;
            }
            this.Logins()
        },
   
        countDown() {    
            if(!this.timer){
                this.timer = setInterval(() => {
                    this.i = this.i - 1;  
                    if(this.i<30){
                        this.isDisabled=true;
                    }else{
                        this.isDisabled=false;
                    }
                    if(this.i<0){
                        this.i=0;
                    }
                    $("#daoshushijian").html(this.i+'s');  
                    if (this.i == 0) {  
                        $("#daoshushijian").html("");  
                        document.getElementById('send-sms').disabled=false;
                        this.flag = 1;  
                        this.i = 30;  
                     
                        clearInterval(this.timer);
                        this.timer=null;
                        this.numTimer++;
                        return;  
                    }  
                }, 1000);
            }
        },
        async SendMessages(){
            let resp=await SendMessage(this.searchForm.LaboratoryNo,this.searchForm.Name,this.searchForm.areaNo+this.searchForm.Phone);
            if(resp.Status){
               if(resp.Status==true){
                    alert("短信已发送，请注意查收");
                    //每秒调用countDown方法，显示动态时间效果
                    this.countDown();
                }else{
                    alert("短信发送失败："+resp.Msg) 
					document.getElementById('send-sms').disabled=false;
                }
            }else{
                 alert(resp.Msg)
            }
        },
        SendMessagesByVoice(){
            //  alert("抱歉，系統正在優化，請於14:30後再進行查詢");
            // return;
            if(this.searchForm.LaboratoryNo==''){
                alert('請輸入報告編號！');
                return;
            }
            if(this.searchForm.Name==''){
                alert('請輸入受測者姓名！')
                return;
            }
            if(this.searchForm.Phone==''){
                alert('請輸入電話號碼！')
                return;
            }
            if (!this.validated())return;
            
            this.SendMessagesVoice();
        },
        /**
         * 語音發送
         */
        async SendMessagesVoice(){
            let resp=await SendMessagesVoice(this.searchForm.LaboratoryNo,this.searchForm.Name,this.searchForm.areaNo+this.searchForm.Phone);
            // if(resp){
            //     if(resp.Status==true){
                    alert("即將撥打電話至你的手機，请注意接聽電話！");
                    //每秒调用countDown方法，显示动态时间效果
                    this.countDown();
            //     }else{
            //         alert("短信发送失败："+resp.Msg)
            //         document.getElementById('send-sms').disabled=false;
            //     }
            // }else{
            //     alert(resp.Msg)
            // }
        },
        async Logins(){
            let resp=await LoginsImg(this.searchForm.LaboratoryNo,this.searchForm.Name,this.searchForm.Phone,this.searchForm.vertify)
            if(resp.Status){
               
				let report = resp.Data;
				if(report==null) {
					//无报告
					alert("沒有查詢到您的相關報告信息，如有疑問請聯繫我們 +852 2865 9399");
					return;
                }
                var beforeFiveOne=new Date(Date.parse('2020/05/07 00:00:00'));//五一前的报告跳转到 不同页面
                var reportDate=new Date(report.ReportDate);
                if(beforeFiveOne>reportDate){
                    this.$store.commit('setReportData', report);
                    this.$router.push({
                        path:'/reportoldresult'
                    })
                }else{
                    // sessionStorage.setItem('ReportData', JSON.stringify(report));
                    //window.open( process.env.BASE_URL + '/' + report);
                    var reports=report.PdfUrlImg.replace("\\", "\/").replace("\\", "\/").split('/');
                    console.log(reports);
                    var newreports=report.PdfUrlImg.replace(reports[reports.length-1],"web"+reports[reports.length-1])
                    this.PdfImgUrl=process.env.BASE_URL + '/' + newreports;
                    //this.dialogImgVisible=true;
                    this.pdfUrl=process.env.BASE_URL + '/' + resp.Data.PdfUrl.replace('jpg','pdf');
                    window.open(this.pdfUrl);
                }
            }else{
                let createTime=resp.Data;
                if(createTime!=""&&createTime!=null&&createTime!=undefined){
                    //跳转到新的检测流程展示进度
                    this.$router.push({
                        path:'/steps?dateTime='+createTime
                    })
                }else{
                  alert("系統提示："+resp.Msg)
                }
            }
        },
        isMobileDevice(){
          let isMobile = false;
          let thisOS = navigator.platform,
              userAgent = navigator.userAgent,
              appVersion = navigator.appVersion;
          let os = ["iPhone","iPod","iPad"]//"android","Nokia","SymbianOS","Symbian","Windows Phone","Phone","Linux armv71","MAUI","UNTRUSTED/1.0","Windows CE","BlackBerry","IEMobile"];
          for(let i=0;i<os.length;i++)
              if(thisOS.match(os[i]) || userAgent.match(os[i] || appVersion.match(os[i])))
                  isMobile = true;

          //因为相当部分的手机系统不知道信息,这里是做临时性特殊辨认
          if(navigator.platform.indexOf('iPad') != -1)
              isMobile = true;

          return isMobile;
      },
        downloadPdf(){
            if (this.isMobileDevice()) {//是苹果手机 无法下载 请到电脑端下载
                alert("由於蘋果IOS系統相關政策不能為您提供下載服務，您可通關電腦端下載您的報告，不便之處，敬請諒解");
                return ;
            }else{
                window.open(this.pdfUrl);
              //this.fileLinkToStreamDownload(this.pdfUrl,'报告下载','application/pdf');
            }
        },
         /**
         * 文件链接转文件流下载--主要针对pdf 解决谷歌浏览器a标签下载pdf直接打开的问题
         * @param url  ：文件链接
         * @param fileName  ：文件名;
         * @param type  ：文件类型;
         */
        fileLinkToStreamDownload(url, fileName, type){
            console.log(url);
            let that=this
            url=url.replace("\\", "\/").replace("\\", "\/")
            let reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/;
            
                let xhr = new XMLHttpRequest();
                xhr.open('get', url, true);
                xhr.setRequestHeader('Content-Type', `application/${type}`);
                xhr.responseType = "blob";
                xhr.onload = function () {
                if (that.status == 200) {
                    //接受二进制文件流
                    var blob = this.response;
                    that.downloadExportFile(blob, fileName, type)
                }
                }
                xhr.send();
            
        },
        /**
         *下载导出文件
        * @param blob  ：返回数据的blob对象或链接
        * @param tagFileName  ：下载后文件名标记
        * @param fileType  ：文件类 word(docx) excel(xlsx) ppt等
        */
        downloadExportFile(blob, tagFileName, fileType) {
            let downloadElement = document.createElement('a');
            let href = blob;
            if (typeof blob == 'string') {
                downloadElement.target = '_blank';
            } else {
                href = window.URL.createObjectURL(blob); //创建下载的链接
            }
            downloadElement.href = href;
            downloadElement.download = tagFileName + (new Date().getTime()).format('YYYYMMDDhhmmss') + '.' + fileType; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            if (typeof blob != 'string') {
                window.URL.revokeObjectURL(href); //释放掉blob对象
            }

        },
    }
    
}
</script>

<style lang="scss" scoped>

  @import '../assets/font/iconfont.css';
.search-reports{
    width: 100%;
   
    margin-top:1rem;
    text-align: center;
    position: relative;
    
    .search-img{
       margin:0 auto;
       .img-ss{
           position: relative;
            .search-background{
                max-width: 100%;
                height: auto;
                position: relative;
            }
            .search-title{
                    width:100%;
                    height: 100%;
                    font-size: 47px;
                    line-height: 60px;
                    color: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                    padding-left:10%;
                    padding-right:10%;
                    font-weight: bold;
                    top:0;
            }
            .search-title:before{
                display: table;
                content:" ";
            }
            .search-title:after{
                display: table;
                content:" ";
            }
            
       }
       
    }

    .search-content{
        clear: both;
        width:1200px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin:auto;
        margin-top:10rem;
        margin-bottom:10rem;
        .content-item-left{
          max-width: 1180px;
          min-width: 800px;
          margin-left:30px;
            .item-left{
                text-align:left;
                ol{
                    padding-inline-start: 20px !important;
                }
                li{
                    padding-left:18px;
                }
                .item-title{
                    color:#368da7;
                    font-size:20px;
                    font-weight: 600;
                    margin-bottom:2rem;
                }
                .item-content{
                    color:#3b3b3b;
                    font-size:18px;
                    font-weight: 400;
                    line-height: 40px;
                    list-style-position: outside;
                    
                }
            }
        }
        .content-item-right{
            min-width:444px;
             margin-right:10px;
            padding-top: 30px!important;
            padding-right: 30px!important;
            padding-bottom: 10px!important;
            padding-left: 30px!important;
            background-color: #368da7!important;
            .content-item-input{
                margin-bottom:20px;
                .select-area{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .select{
                        border-color: #e9e9e9;
                        border-width: 1px;
                        border-style: solid;
                        color: #3b3b3b;
                        font-family: Arial;
                        font-size: 14px;
                        line-height: 18px;
                        font-style: normal;
                        font-weight: 400;
                        letter-spacing: 0px;
                        text-transform: none;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        padding-left:10px;
                        margin-right:20px;
                    }
                }
                input{
                        width:100%;
                        border-color: #e9e9e9;
                        border-width: 1px;
                        border-style: solid;
                        color: #3b3b3b;
                        font-family: Arial;
                        font-size: 14px;
                        line-height: 18px;
                        font-style: normal;
                        font-weight: 400;
                        letter-spacing: 0px;
                        text-transform: none;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        padding-left:10px;
                }
                .error-img{
                    width:1.8rem;
                    height: 0.8rem;
                    margin-left:1rem;
                    margin-right: 0.3rem;
                    color:#fe0000;
                }
                .sms-speaker{
                    color:#fe0000;
                    width: 100%;
                    text-align: left;
                    font-size:14px;
                    cursor: pointer;
                    text-decoration: underline;
                }
                .form-btn-send{
                        width:40%;
                       color:#ffffff;
                        background-color: #51cedd;
                        border-color: #51cedd;
                        border: 2px solid #51cedd;
                        font-family: Arial;
                        font-size: 14px;
                        line-height: 18px;
                        font-style: normal;
                        font-weight: 400;
                        letter-spacing: 0px;
                        text-transform: none;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        margin-left:20px;
                }
                .select-warning{
                    display: flex;
                    justify-content: left;
                    align-items: center;
                }
                .checekboxs-div{
                    text-align: left !important;
                    width: 5% !important;
                    display: flex;
                    justify-content: left;
                    align-items: center;
                }
                .checekboxs{
                    clear: both;
                    -webkit-writing-mode: horizontal-tb !important;
                    text-rendering: auto;
                    color: -internal-light-dark-color(black, white);
                    letter-spacing: normal;
                    word-spacing: normal;
                    text-transform: none;
                    text-indent: 0px;
                    text-shadow: none;
                    display: inline-block;
                    text-align: start;
                    margin: 0 0;
                    
                }
                .warning{
                    color: #fff;
                    font-size: 12px;
                    width:100%;
                    text-align: left;
                    margin-left:5px;
                }
                .submit-div{
                    clear: both;
                    display: flex;
                    justify-content: center;
                    text-align: center !important;
                }
                .submit-btn{
                        width:25%;
                        border-width: 1px;
                        border-style: solid;
                        font-family: Arial;
                        font-size: 14px;
                        line-height: 18px;
                        font-style: normal;
                        font-weight: 400;
                        letter-spacing: 0px;
                        text-transform: none;
                        padding-top: 10px;
                        padding-bottom: 10px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        color:#ffffff;
                        background-color: #51cedd;
                        border-color: #51cedd;
                        border: 2px solid #51cedd;
                        border-radius: 6px;
                       
                }
                .submit-btn:hover{
                    color: #51cedd;
                    background-color: #ffffff;
                    border-color: #ffffff;
                }
            }
        }
    }

    .send_smsspe{
        background:#eeeeee !important;
        border-color: #e9e9e9 !important;
        border-width: 1px !important;
        border-style: solid !important;
        color: #3b3b3b !important;
    }
    .vertifys{
        width:160px !important;
    }

    
}
.btn_div{
   display: flex;
   justify-content: flex-end;
    text-align: right;
}
.btn_down{
    
    width:140px;
    height: 40px;
    background-color: #368da7;
    color: #fff;
    border-radius: 50px;
    border: solid 1px #368da7;
    text-decoration: none;
    cursor: pointer;
    font-size: 18px !important;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}
.baocun{
    color:#fff;
    font-size:18px;
    cursor: pointer;
    font-weight: bold;
    margin-left:5px;
}


</style>



// WEBPACK FOOTER //
// src/view/Yreport.vue